export default "__VITE_ASSET__CETBTD9D__"